function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { formatDate } from 'helpers/datetime';
import messages from '../../messages';
import styles from './VisitCard.pcss';
const VisitCard = ({ visit, onShowNotes })=>{
    useStyles(styles);
    const onClick = (evt)=>{
        evt.preventDefault();
        onShowNotes(visit);
    };
    const { createdBy, visitDate } = visit.metadata;
    const { firstName, lastName, clinic } = createdBy;
    const clinicInfo = clinic ? `${clinic.name}, ${clinic.city}` : '';
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.visitCard,
        onClick: onClick,
        onKeyDown: undefined,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex justify-content-between w-100 text--large text--medium",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: formatDate(visitDate)
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            firstName,
                            " ",
                            lastName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex justify-content-between w-100 text--base",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: Number(visit.newMessages) > 0 ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.labels.visitMessages), {
                            values: {
                                number: visit.newMessages
                            }
                        })) : null
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text--light",
                        children: clinicInfo
                    })
                ]
            })
        ]
    });
};
export default VisitCard;
